export default "__VITE_ASSET__fL9NUEIA__"